import * as React from "react";
import type { SVGProps } from "react";
const SvgItemDocumentImageCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24" {...props}
  >
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.248 16.504h4.002M17.753 15.566l-1.877 1.877-1.125-1.126"
    />
    <rect
      width={18.008}
      height={18.008}
      x={3.246}
      y={2.996}
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      rx={3}
    />
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.251 13H7.248"
    />
    <rect
      width={3.501}
      height={3.001}
      x={7.248}
      y={7}
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      rx={0.5}
    />
  </svg>
);
export default SvgItemDocumentImageCheckmark;
